import { Navigate, useParams } from "react-router-dom";
import { PAGE_PATHS, PageMasterMode } from "./PageContext";
import { SessionMode } from "../../contexts/appStore/hooks";

/**
 * Tiny redirect route mounted at `/j/:shortId`.
 *
 * The QR code shown in the lobby points at this short URL so that flyers,
 * displays, and shared links stay short. We forward to the regular lobby
 * route, which already resolves shortIds via `meeting.getById`.
 */
export const JoinShortIdRedirect = () => {
  const { shortId } = useParams();
  if (!shortId) {
    return <Navigate to={PAGE_PATHS[SessionMode.MASTER][PageMasterMode.LIST]} replace />;
  }
  return <Navigate to={`/lobby/${shortId}`} replace />;
};
